import CoachSpecializedSkillsRow from './coach-specialized-skills-row'

export { coachSpecializedSkillsRowHasContent } from './coach-specialized-skills-row'
export default CoachSpecializedSkillsRow
